import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBottomSheet",
    _vm._b(
      {
        attrs: {
          "data-qa": "appointment_data_modal",
          "is-visible": _vm.isVisible,
          "content-class": _vm.contentClassProp,
        },
        on: { "dialog-bottom-sheet:change-visible": _vm.handleChangeVisible },
        scopedSlots: _vm._u(
          [
            {
              key: "activator",
              fn: function (props) {
                return [_vm._t("activator", null, null, props)]
              },
            },
          ],
          null,
          true
        ),
      },
      "DialogBottomSheet",
      _vm.$attrs,
      false
    ),
    [
      _vm._v(" "),
      _c(
        VCard,
        {
          staticClass: "d-flex flex-column",
          attrs: {
            "data-qa": "appointment_data_modal_body",
            height: "100%",
            tile: _vm.isMobile,
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-center px-2 py-4 text--text" },
            [
              _vm.hasCloseIcon && !_vm.$attrs.persistent
                ? _c("span", {
                    directives: [
                      {
                        def: Ripple,
                        name: "ripple",
                        rawName: "v-ripple",
                        value: _vm.isDisabled ? false : { center: true },
                        expression: "isDisabled ? false : { center: true }",
                      },
                    ],
                    staticClass:
                      "ui-icon-close-not-a-circle rounded-circle mr-8 cursor-pointer",
                    class: { "disabled--text": _vm.isDisabled },
                    attrs: { "data-qa": "appointment_data_modal_close_btn" },
                    on: {
                      click: function ($event) {
                        _vm.isDisabled ? undefined : _vm.handleCloseModal()
                      },
                    },
                  })
                : _vm.hasBackIcon
                ? _c("span", {
                    directives: [
                      {
                        def: Ripple,
                        name: "ripple",
                        rawName: "v-ripple",
                        value: _vm.isDisabled ? false : { center: true },
                        expression: "isDisabled ? false : { center: true }",
                      },
                    ],
                    staticClass:
                      "ui-icon-arrow-back rounded-circle mr-8 cursor-pointer",
                    class: { "disabled--text": _vm.isDisabled },
                    attrs: { "data-qa": "appointment_data_modal_back_btn" },
                    on: {
                      click: function ($event) {
                        _vm.isDisabled ? undefined : _vm.handleBackModal()
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "text-h6",
                  attrs: { "data-qa": "appointment_data_modal_title" },
                },
                [_vm._v(_vm._s(_vm.$i18next.t(_vm.title, _vm.options)))]
              ),
            ]
          ),
          _vm._v(" "),
          _vm.hasDivider ? _c(VDivider) : _vm._e(),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }